import LTR from "@brand-icons/ploom/edit/edit-ltr.svg";

import { iconFactory } from "../iconFactory";

export const EditIcon = iconFactory("EditIcon", LTR);
